import { Inject, Injectable } from '@angular/core';
import {
  ITU_CODE,
  OWNER_SUBENTITIES,
} from '@adlatus-gui/domain/clearing-custom';

@Injectable({
  providedIn: 'root',
})
export class TicketOriginatorUtil {

  constructor(
    @Inject(ITU_CODE) private ituCode: string[],
    @Inject(OWNER_SUBENTITIES) private ownerSubEntities: string[]
  ) {
  }

  isOriginatorPlatform(originator: string) {
    return (
      this.ituCode.includes(originator) || this.ownerSubEntities.includes(originator)
    );
  }
}
